import styled from "styled-components";

export default styled.div`
  padding: 15px 25px;
  margin-bottom: 15px;
`;
